import type { ArtifactStatus, JobStatus } from "@shared/types";

const ARTIFACT_STYLES: Record<ArtifactStatus, string> = {
  done: "bg-emerald-100 text-emerald-800 ring-emerald-200",
  draft: "bg-amber-100 text-amber-800 ring-amber-200",
  failed: "bg-rose-100 text-rose-800 ring-rose-200",
  pending: "bg-slate-100 text-slate-600 ring-slate-200",
};

const ARTIFACT_LABEL: Record<ArtifactStatus, string> = {
  done: "Done",
  draft: "Draft",
  failed: "Failed",
  pending: "Pending",
};

export function ArtifactStatusBadge({ status }: { status: ArtifactStatus }) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ring-1 ring-inset ${ARTIFACT_STYLES[status]}`}
    >
      {ARTIFACT_LABEL[status]}
    </span>
  );
}

const JOB_STYLES: Record<JobStatus, string> = {
  complete: "bg-emerald-100 text-emerald-800 ring-emerald-200",
  partial: "bg-amber-100 text-amber-800 ring-amber-200",
  processing: "bg-sky-100 text-sky-800 ring-sky-200",
  failed: "bg-rose-100 text-rose-800 ring-rose-200",
  pending: "bg-slate-100 text-slate-600 ring-slate-200",
};

const JOB_LABEL: Record<JobStatus, string> = {
  complete: "Complete",
  partial: "Needs attention",
  processing: "Processing",
  failed: "Failed",
  pending: "Pending",
};

export function JobStatusBadge({ status }: { status: JobStatus }) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ring-1 ring-inset ${JOB_STYLES[status]}`}
    >
      {JOB_LABEL[status]}
    </span>
  );
}
